"use strict";

var _StrictMode;
import { LoggingAgentProvider } from '@autoguru/logs';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@autoguru/overdrive/dist/styles/global/reset.css';
import '@autoguru/overdrive/dist/styles/global/fonts.css';
import { OverdriveProvider } from '@autoguru/overdrive';
import { SupportedBrowsersBoundary } from '@autoguru/supported-browser-boundary';
import { getMfeMountPoint } from 'gdu/dist/lib/mfe';
import AGSupportedBrowsers from '~/browsers';
import * as guruConfigs from '../guru.config';
import { App } from './App';
import { jsx as _jsx } from "react/jsx-runtime";
const root = getMfeMountPoint({
  mountDOMId: guruConfigs.mountDOMId,
  projectName: __GDU_APP_NAME__
});
const MFE = () => createRoot(root).render(_StrictMode || (_StrictMode = /*#__PURE__*/_jsx(StrictMode, {
  children: /*#__PURE__*/_jsx(LoggingAgentProvider, {
    children: /*#__PURE__*/_jsx(OverdriveProvider, {
      children: /*#__PURE__*/_jsx(SupportedBrowsersBoundary, {
        browsers: AGSupportedBrowsers,
        children: /*#__PURE__*/_jsx(App, {})
      })
    })
  })
})));
export default MFE;